import React from "react"
import { AppHeader } from "@nike/eds/dist/components/AppHeader/AppHeader"
import { Avatar } from "@nike/eds/dist/components/Avatar/Avatar"
import NikeLogoImg from "../../nike-logo.svg"
import { useOktaAuth } from "@okta/okta-react";
import "./Header.css";
import Navigation from "./Navigation";

function Header() {
    const { authState } = useOktaAuth();
    const email = authState?.accessToken?.claims?.sub;
    const initials = (email && email.indexOf("@") !== -1) ? getInitialsFromEmail(email) : "  ";
    const NikeLogo = ( <img src={ NikeLogoImg } alt="Nike Logo" /> );

    return (
        <AppHeader logoSlot={NikeLogo} appName={"Trade Compliance"} isDark={true} commandBarSlot={<Navigation />} avatarSlot={(<Avatar initials={initials} />)}></AppHeader>
    )
}

function getInitialsFromEmail(email: string) {
    const [first, last] = email.split("@")[0].split(".");
    return first[0] + last[0];
}

export default Header;